function round($filter) {
  'ngInject';
  return function(number, allowZero, shortAbove) {

    if (!number && allowZero) {
      return 0;
    }

    if (!number) {
      return 'n/a';
    }

    return $filter('shortNumber')(number, 0, shortAbove);

  };
}

export { round };
